var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIkObowiazkowe = function SvgIkObowiazkowe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.994,
    height: 22.995
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8779"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6400"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3418",
    d: "M20.597 16.736a10.494 10.494 0 0 1-9.1 5.259 10.5 10.5 0 0 1-10.5-10.5 10.5 10.5 0 0 1 10.5-10.5 10.46 10.46 0 0 1 7.065 2.734 10.472 10.472 0 0 1 3.432 7.764",
    fill: "none",
    stroke: "#156BB7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8736",
    fill: "none",
    stroke: "#156BB7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 280",
    d: "M11.497 5.394v9.133"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 362",
    d: "M11.497 17.7h0"
  })))));
};
export default SvgIkObowiazkowe;